import { Transition } from '@headlessui/react'
import clsx from 'clsx'
import { useState, Fragment } from 'react'

import type { CarouselProps } from './type'

import { CarouselControl } from './CarouselControl'

export const Carousel = ({ items }: CarouselProps) => {
  const [itemIndex, setItemIndex] = useState<number>(0)

  return (
    <div
      className={clsx('tw-relative', 'tw-w-full', 'tw-flex tw-justify-center')}
    >
      {/* control: prev */}
      <CarouselControl
        isPrev={true}
        onClick={() =>
          setItemIndex(itemIndex <= 0 ? items.length - 1 : itemIndex - 1)
        }
      />

      {/* items */}
      <div
        className={clsx(
          'tw-relative',
          'tw-aspect-[16/10] tw-w-full tw-max-w-lg'
        )}
      >
        {items.map((item, i) => (
          <Transition
            key={`item-${i}`}
            show={itemIndex === i}
            as={Fragment}
            enter={clsx('tw-transition-opacity tw-ease-in tw-duration-300')}
            enterFrom={clsx(['tw-opacity-0'])}
            enterTo={clsx(['tw-opacity-100'])}
            leave={clsx(['tw-transition-opacity tw-ease-in tw-duration-300'])}
            leaveFrom={clsx(['tw-opacity-100'])}
            leaveTo={clsx(['tw-opacity-0'])}
          >
            <div
              className={clsx(
                'tw-absolute',
                'tw-left-0 tw-top-0',
                'tw-h-full tw-w-full'
              )}
            >
              {item.content}
            </div>
          </Transition>
        ))}
      </div>

      {/* control: next */}
      <CarouselControl
        isPrev={false}
        onClick={() =>
          setItemIndex(itemIndex <= 0 ? items.length - 1 : itemIndex - 1)
        }
      />
    </div>
  )
}
